<template>
  <nx-bform
    ref="form"
    @submit="onSubmit"
    class="e-registration-public-register-form"
  >
    <h5>
      {{ $t("title") }}
    </h5>
    <p class="text-muted">
      {{ $t("titleDesc") }}
    </p>

    <nx-bform-server-errors />

    <RegistrationLoginNameFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.username"
      :description="$t('loginNameReminder')"
    />

    <!-- <RegistrationEnglishNameFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.nameEng"
    /> -->

    <RegistrationNameTitleFormGroup
      label-cols="2"
      label-align="right"
      v-model="form.title"
      required
    />

    <RegistrationSurnameFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.surname"
    />

    <RegistrationGivenNameFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.givenName"
    />

    <RegistrationChineseNameFormGroup
      label-cols="2"
      label-align="right"
      v-model="form.nameChinese"
    />

    <RegistrationEmailFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.email"
    />

    <RegistrationTelephoneFormGroup
      label-cols="2"
      label-align="right"
      v-model="form.telephone"
    />

    <RegistrationLanguageFormGroup
      label-cols="2"
      label-align="right"
      v-model="form.lang"
    />

    <CaptchaFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.captcha"
      @change-token="form.captchaToken = $event.token"
    />

    <b-form-group label-cols="2">
      <b-button type="submit" variant="primary" v-t="'send'" />
      <!--<b-button class="ml-2" @click="resetForm" v-t="'reset'" />-->
      <b-button class="ml-2" @click.prevent="onCancel" v-t="'cancel'" />
    </b-form-group>
  </nx-bform>
</template>

<script>
import { assign } from "lodash";
import { MemberRegistrationApi } from "@/api";
import RegistrationLoginNameFormGroup from "@/forms/registration/RegistrationLoginNameFormGroup";
import RegistrationNameTitleFormGroup from "@/forms/registration/RegistrationNameTitleFormGroup";
import RegistrationSurnameFormGroup from "@/forms/registration/RegistrationSurnameFormGroup";
import RegistrationGivenNameFormGroup from "@/forms/registration/RegistrationGivenNameFormGroup";
import RegistrationEnglishNameFormGroup from "@/forms/registration/RegistrationEnglishNameFormGroup";
import RegistrationChineseNameFormGroup from "@/forms/registration/RegistrationChineseNameFormGroup";
import RegistrationEmailFormGroup from "@/forms/registration/RegistrationEmailFormGroup";
import RegistrationTelephoneFormGroup from "@/forms/registration/RegistrationTelephoneFormGroup";
import RegistrationLanguageFormGroup from "@/forms/registration/RegistrationLanguageFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";

export default {
  data() {
    return {
      form: this.getForm(),
    };
  },
  components: {
    RegistrationLoginNameFormGroup,
    RegistrationNameTitleFormGroup,
    RegistrationSurnameFormGroup,
    RegistrationGivenNameFormGroup,
    RegistrationEnglishNameFormGroup,
    RegistrationChineseNameFormGroup,
    RegistrationEmailFormGroup,
    RegistrationTelephoneFormGroup,
    RegistrationLanguageFormGroup,
    CaptchaFormGroup,
  },
  methods: {
    getForm() {
      return {
        username: "",
        title: "Mr",
        nameEng: "",
        surname: "",
        givenName: "",
        nameChinese: "",
        email: "",
        telephone: "",
        lang: "en",
        captcha: "",
        captchaToken: "",
      };
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
    },
    async onSubmit(evt) {
      const { form } = this;
      const registry = {
        registrationProfileKey: "Public",
        loginName: form.username,
        fullname: form.nameEng,
        email: form.email,
        phone: form.telephone,
        language: form.lang,
        propertyValues: {
          chineseName: form.nameChinese,
          surname: form.surname,
          givenName: form.givenName,
          title: form.title
        },
      };

      await MemberRegistrationApi.register(registry, form.captchaToken);

      this.$router.push({ name: "ERegistrationRegisterSuccess" });
    },
    async onCancel() {
      console.log("CANCEL SUBMIT");
      this.show = false;
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Application for registration as a public user of Electronic Submission Hub",
    "titleDesc": "To become a registered user, please complete the following application form. All fields with (*) are mandatory.",
    "loginNameReminder": "Login name will be used for future login and cannot be changed once accepted by the System"
  },
  "zh_hk": {
    "title": "申請註冊為電子提交中心的公共用戶",
    "titleDesc": "要成為註冊用戶，請填寫以下申請表格。帶（*）的所有字段均為必填項。",
    "loginNameReminder": "登錄名將用於將來的登錄，一旦系統接受，便無法更改"
  },
  "zh_cn": {
    "title": "申请注册为电子提交中心的公共用户",
    "titleDesc": "要成为注册用户，请填写以下申请表格。带（*）的所有字段均为必填项。",
    "loginNameReminder": "登录名将用于将来的登录，一旦系统接受，便无法更改"
  }
}
</i18n>
